var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "video-svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_1837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 112C2.68629 112 0 109.314 0 106V22C0 18.6863 2.68629 16 6 16H122C125.314 16 128 18.6863 128 22V106C128 109.314 125.314 112 122 112H6Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8 22C0.8 19.1281 3.12812 16.8 6 16.8H122C124.872 16.8 127.2 19.1281 127.2 22V106C127.2 108.872 124.872 111.2 122 111.2H6C3.12812 111.2 0.8 108.872 0.8 106V22Z",
    stroke: "#EBECF0",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 112H122C125.314 112 128 109.314 128 106V102C128 105.314 125.314 108 122 108H6C2.68629 108 0 105.314 0 102V106C0 109.314 2.68629 112 6 112Z",
    fill: "#EBECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7367 44.8683L85.8534 62.9267C86.7378 63.3689 86.7378 64.6311 85.8534 65.0733L49.7367 83.1317C48.9388 83.5306 48 82.9504 48 82.0584V45.9416C48 45.0496 48.9388 44.4694 49.7367 44.8683Z",
    fill: "#7A869A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_1837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0ea81fe8fe3d0d1914747007b79465f9.svg";
export { ForwardRef as ReactComponent };